import { db } from "./Firebase"

const tblProducts = 'products'
const tblFeatures = 'features'

export default {
   getRef() {
      return db().ref(tblFeatures)
   },
   getRefByProduct(productId) {
      return db().ref(tblFeatures).orderByChild('product_id').equalTo(productId)
   },
   getFeatureById(id) {
      return db().ref(tblFeatures).child(id).once('value')
   },
   storeFeature(obj) {
      let timestamp     = new Date().getTime()
      let newFeatureKey = db().ref(tblFeatures).push().key

      let featureData = {
         id        : newFeatureKey,
         property  : obj.property,
         value     : obj.value,
         status    : obj.status ? '1' : '0',
         product_id: obj.product_id != null ? obj.product_id: '',
         created_at: timestamp,
         updated_at: timestamp,
      }
      let updates = {}
      updates[`/${tblFeatures}/${newFeatureKey}`] = featureData
      if (obj.product_id != '') {
         updates[`/${tblProducts}/${obj.product_id}/features/${newFeatureKey}`] = true
      }

      return db().ref().update(updates)
   },
   updateFeature(obj) {
      let timestamp     = new Date().getTime()

      let featureData = {
         id        : obj.id,
         property  : obj.property,
         value     : obj.value,
         status    : obj.status ? '1' : '0',
         product_id: obj.product_id != null ? obj.product_id: '',
         created_at: obj.created_at,
         updated_at: timestamp,
      }

      let updates = {}
      updates[`/${tblFeatures}/${obj.id}`] = featureData

      return db().ref().update(updates)
   },
   updateStatus(obj){
      let timestamp = new Date().getTime()

      let featureData = {
         status    : obj.status ? '1': '0',
         updated_at: timestamp
      }

      return db().ref(tblFeatures).child(obj.id).update(featureData)
   },
   deleteFeature(id, productId) {
      let updates = {}
      updates[`/${tblFeatures}/${id}`] = null
      updates[`/${tblProducts}/${productId}/features/${id}`] = null

      return db().ref().update(updates)
   }
}
